module.exports = __webpack_public_path__ + "static/media/lykke02.fe968e77.jpg";